
import React from 'react';
import { Card, CardContent, CardFooter } from "./ui/card";
import { Button } from "./ui/button";
import { useNavigate, useLocation } from 'react-router-dom';

const ComboCard = ({ combo }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleOrderClick = () => {
    if (location.pathname === '/') {
        // If already on Home, just scroll
        const section = document.getElementById('lojas');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    } else {
        // If elsewhere, navigate Home then scroll
        navigate('/');
        // Small timeout to allow Home to mount
        setTimeout(() => {
            const section = document.getElementById('lojas');
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    }
  };

  return (
    <Card className="h-full border-none shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col group">
      <div className="h-48 overflow-hidden relative">
        <img 
            src={combo.image} 
            alt={combo.name} 
            className="w-full h-full object-cover transition-transform hover:scale-110 duration-700"
        />
        <div className="absolute top-0 right-0 bg-[#E63312] text-white px-4 py-1 font-bold rounded-bl-lg uppercase tracking-wider text-sm shadow-md">
            Promoção
        </div>
      </div>
      <CardContent className="p-6 text-center flex-grow flex flex-col items-center">
        <h3 className="text-2xl font-black text-gray-800 mb-4 uppercase">{combo.name}</h3>
        <ul className="space-y-3 mb-6 text-gray-600 font-medium w-full">
            {combo.items.map((item, idx) => (
                <li key={idx} className="border-b border-dashed border-gray-200 pb-2 last:border-0">{item}</li>
            ))}
        </ul>
        <div className="mt-auto">
             <p className="text-4xl font-black text-[#E63312] mb-2">{combo.price}</p>
        </div>
      </CardContent>
      <CardFooter className="p-6 pt-0">
        <Button 
            onClick={handleOrderClick}
            className="w-full bg-[#E63312] hover:bg-black text-[#FFC300] hover:text-white font-bold h-14 rounded-xl text-xl uppercase tracking-wider shadow-lg transition-colors"
        >
            PEÇA JÁ
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ComboCard;
